import React from 'react';
import styled from 'styled-components';

const Element = styled.span`
  font-weight: ${props => (props.weight ? props.weight : 'normal')};
  font-size: ${props => (props.size ? props.size : 'inherit')};
`;

const Font = props => (
  <Element weight={props.weight} size={props.size}>
    {props.children}
  </Element>
);

export default Font;
